import { useEffect, useRef } from 'react';

const useScrollIntoViewRef = () => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest'
    });
  }, [ref.current]);

  return ref;
};

export default useScrollIntoViewRef;
